import React from "react";
import "./LoginPage.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { API_BASE_URL } from "./api";
import WhatsAppFloat from "./components/WhatsAppFloat";
import { startSsoLogin as startSsoPopup } from "./ssoPopup";

const SSO_ENTRY_URL = `${API_BASE_URL}/sso/entrar/`;
const SSO_POPUP_FEATURES = "width=480,height=720,menubar=no,toolbar=no,location=yes";
const WHATSAPP_LINK = "https://bitlybr.net/b2b-wpp-suporte?text=Oi!%20Preciso%20de%20ajuda%20no%20DadosPJ.";

const ERROR_MESSAGES = {
  expirado: "Seu link de acesso expirou. Clique em Entrar novamente.",
  conta_interna: "Esta é uma conta da equipe. Use o acesso administrativo.",
  conflito: "Não foi possível liberar seu acesso. Fale com o suporte.",
  inativa: "Não foi possível liberar seu acesso. Fale com o suporte.",
  limite: "Muitas tentativas agora. Aguarde alguns minutos e tente de novo.",
  indisponivel: "A Área do Cliente está instável no momento. Tente novamente em instantes.",
  sso: "Não foi possível entrar pela Área do Cliente. Tente novamente.",
};

const SUPORTE_CODES = new Set(["conflito", "inativa"]);

export default function LoginPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const erroCode = searchParams.get("erro");
  const erro = erroCode ? (ERROR_MESSAGES[erroCode] || ERROR_MESSAGES.sso) : null;

  /**
   * O campo de senha nunca vive no DadosPJ para cliente (login único pela Área do Cliente).
   * A janelinha mostra a Área do Cliente na barra de endereço ao digitar a senha. Ela avisa esta
   * janela e se fecha; quem entra no painel é esta janela (ver ssoPopup.js). Se o login falhar
   * do outro lado, a janelinha manda o código de volta e esta janela mostra a mensagem.
   */
  function startSsoLogin() {
    startSsoPopup(SSO_ENTRY_URL, SSO_POPUP_FEATURES, (codigo) => {
      navigate(`/login?erro=${encodeURIComponent(codigo)}`, { replace: true });
    });
  }

  return (
    <div className="lp-bg">
      {/* Efeitos de fundo */}
      <div className="lp-bg-orb lp-bg-orb-1" />
      <div className="lp-bg-orb lp-bg-orb-2" />
      <div className="lp-bg-orb lp-bg-orb-3" />

      {/* Card principal */}
      <div className="lp-card-wrap">
        <div className="lp-card">

          {/* ── LADO ESQUERDO: logo + boas-vindas ── */}
          <div className="lp-panel-left">
            <div className="lp-panel-left-inner">
              <img
                src={`${process.env.PUBLIC_URL}/Logo-dark.png`}
                alt="DadosPJ"
                className="lp-logo"
              />
              <div className="lp-divider" />
              <h2 className="lp-welcome-title">Olá, bem‑vindo!</h2>
              <p className="lp-welcome-sub">
                A plataforma de prospecção B2B mais completa do Brasil. Encontre leads qualificados e expanda seus negócios.
              </p>
              <div className="lp-badges">
                <span>+70M empresas</span>
                <span>Dados atualizados</span>
                <span>Exportação rápida</span>
              </div>
            </div>
          </div>

          {/* ── DIVISOR ── */}
          <div className="lp-separator" />

          {/* ── LADO DIREITO: acesso ── */}
          <div className="lp-panel-right">
            <div className="lp-form">

              <div className="lp-form-header">
                <h3>Acessar plataforma</h3>
                <p>Sua conta é criada pela Área do Cliente — entre por aqui.</p>
              </div>

              {erro && (
                <div className="lp-error">
                  {erro}
                  {erroCode === "conta_interna" && (
                    <>
                      {" "}
                      <a href="/admin-login">Ir para o acesso administrativo</a>
                    </>
                  )}
                  {SUPORTE_CODES.has(erroCode) && (
                    <>
                      {" "}
                      <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer">
                        Falar no WhatsApp
                      </a>
                    </>
                  )}
                </div>
              )}

              <button className="lp-btn" type="button" onClick={startSsoLogin}>
                Entrar com a Área do Cliente
              </button>

            </div>
          </div>

        </div>
      </div>

      <WhatsAppFloat />
    </div>
  );
}
